import cx from 'classnames';
import styles from '../../styles/plan/planTitle.scss';
import {
  ELSS_POINTS,
  CDN_CLRSAVE_URL,
  ELSS_POINTS_VARIANT_B,
} from '../../constants';

export const PlanPoints = (props: any) => {
  const dataPoints = props.isVariant ? ELSS_POINTS_VARIANT_B : ELSS_POINTS;
  return (
    <ul className="mt20 mb20">
      {dataPoints.map(tip => (
        <li
          className={cx(
            'font--dark-grey text--xmd lil-flex lil-text-font-500',
            styles['tip-item']
          )}
          key={tip.text}
        >
          <img
            src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/${tip.icon}`}
            className={styles['tip-icon']}
          />
          <span>{tip.text}</span>
        </li>
      ))}
    </ul>
  );
};

export default PlanPoints;



// WEBPACK FOOTER //
// ./components/plan/planPoints.tsx